module.exports = "/_next/static/images/ab4cc76b29aa7a9879f37822bb718dc6-mother-and-daugther@2x.jpg";